import { render, staticRenderFns } from "./MasterInventoryItem.vue?vue&type=template&id=1a6e7440"
import script from "./MasterInventoryItem.vue?vue&type=script&lang=js"
export * from "./MasterInventoryItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports